/**
 * Common Parameters Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    commonParameter: {},
    commonParameters: []
};

// Getters
const getters = {
    commonParameter: state => {
        return state.commonParameter
    },

    commonParameters:state=>{
        return state.commonParameters
    }
};

// Actions
const actions = {
    getCommonParameters(context, payload) {
        function successCallback(response) {
            //Fetch all common parameter
            // context.commit('getCommonParametersHandler', { commonParameters: response.data.parametres_commun });

            //Fetch common parameter of specific consultation
            context.commit('getCommonParametersHandler', { commonParameters: response.data.consultation.parametres_commun });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        //Fetch all common parameter
        // makeApiRequest(payload.args, apiModel.Parameter.Common.List, localToken, successCallback, errorCallback, payload.errorMessages);

        //Fetch common parameter of specific consultation
        makeApiRequest(payload.args, apiModel.Consultation.General.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCommonParameter(context, payload) {
        function successCallback(response) {
            context.commit('getCommonParameterHandler', { commonParameter: response.data.parametreCommun });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Common.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createCommonParameter(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'parameters-common', params: { consultation: response.data.parametreCommun.consultation.slug } });
            router.push((router.resolve({ name: 'consultation-general', params: { consultation: response.data.parametreCommun.consultation.slug } }).href) +"#parametreCommun");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Common.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateCommonParameter(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'parameters-common', params: { consultation: response.data.parametreCommun.consultation.slug } });
            store.dispatch('findAndRemove', {name: 'consultation-general' });
            store.dispatch('findAndRemove', {name: 'edit-parameter-common' });

            if(!_.isNull(response.data.parametreCommun.consultation)){
                router.push((router.resolve({ name: 'consultation-general', params: { consultation: response.data.parametreCommun.consultation.slug } }).href) +"#parametreCommun");
            }else if(response.data.parametreCommun.communable_type == 'Cardiologie'){
                router.push((router.resolve({ name: 'consultation-cardiology', params: { consultation: response.data.parametreCommun.communable.slug } }).href) +"#parametreCommun");
            }

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Common.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteCommonParameter(context, payload) {
        function successCallback(response) {
            context.commit('deleteCommonParameterHandler', { index: payload.index, successMessage: payload.successMessage, response: response });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Parameter.Common.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getCommonParametersHandler(state, { commonParameters }) {
        // Update commonParameters state
        state.commonParameters = commonParameters;
    },

    getCommonParameterHandler(state, { commonParameter }) {
        // Update commonParameter state
        state.commonParameter = commonParameter;
    },

    deleteCommonParameterHandler(state, { index, successMessage,response }) {
        let i = state.commonParameters.findIndex(commonParameter => commonParameter.slug === index);

        if (~i) {

            state.commonParameters.splice(i, 1);

            // router.push({ name: 'parameters-common', params: { consultation: response.data.parametreCommun.consultation.slug } });
            router.push((router.resolve({ name: 'consultation-general', params: { consultation: response.data.parametreCommun.consultation.slug } }).href) +"#parametreCommun");

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}